import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill, RegularShape } from 'ol/style.js';
import GeoJSON from "ol/format/GeoJSON";
import { Circle as CircleStyle, Text } from 'ol/style';
import { easeOut } from 'ol/easing.js';
import { fromLonLat } from 'ol/proj.js';
import { getVectorContext } from 'ol/render.js';
import { unByKey } from 'ol/Observable.js';
import { hexToRgba, settingsConfig } from 'utils/commonFunc';
import { reverseProgressValue, runAnimationFeature, runAnimationLayerList, setMapSingleEventHandler } from 'map/OlExtension'
import { Feature } from 'ol';
import { LineString, Point } from 'ol/geom';

export default class CommonGuidelineLayer extends VectorLayer {

    constructor(map) {
        super({
            name: 'guidlineLayer',
            source: new VectorSource(),
            style:new Style({
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 0.5)',
                    width: 2,
                })})
        });
        this.map = map;
    }

    update = (lines) => {
        const source = this.getSource()
        source.clear();
        const features = []
        lines.forEach(line => {
            features.push(new Feature({
                geometry: new LineString(line.map(p => fromLonLat(p))),
            }))
        })
        source.addFeatures(features)
    }
}